import { render, staticRenderFns } from "./FileThumbnailDisplay.vue?vue&type=template&id=c66cff00&scoped=true&"
import script from "./FileThumbnailDisplay.vue?vue&type=script&lang=js&"
export * from "./FileThumbnailDisplay.vue?vue&type=script&lang=js&"
import style0 from "./FileThumbnailDisplay.vue?vue&type=style&index=0&id=c66cff00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66cff00",
  null
  
)

export default component.exports